<template>
  <div
    class="not-found"
    :class="{
      'song-not-found': props.renderType === 'songNotFound',
    }"
  >
    <img
      class="not-img"
      src="@/assets/img/notfound/notfound.png"
      alt=""
      v-if="props.renderType === 'notfound'"
    />
    <img
      class="not-img-song"
      src="@/assets/img/empty-ico.png"
      alt=""
      v-if="props.renderType === 'songNotFound'"
    />
    <div class="not-text" v-if="props.renderType === 'songNotFound'">
      {{ $$t("create.the_song_does_not_exist") }}
    </div>
    <div class="create-button pointer" @click="goCreate()">
      <img class="icon-music" src="@/assets/img/land/icon_music.png" alt="" />
      <div class="create-text">{{ $$t("login.create_a_song") }}</div>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import { $$language, $$t, $$tValue } from "@/i18n/i18n.js";

const createLayoutStore = useCreateLayoutStore();
const Router = useRouter();

const props = defineProps({
  renderType: {
    type: String,
    default: "notfound", // songNotFound
  },
});

const goCreate = () => {
  createLayoutStore.toggleCreateEditOpenState(true);
  Router.push({
    name: "create",
  });
};
</script>

<style lang="scss" scoped>
.not-found {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .not-img {
    display: block;
    width: 360px;
    height: 360px;
  }
  .not-img-song {
    display: block;
    width: 160px;
    height: 160px;
  }
  .not-text {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 22px;
    color: rgba(255, 255, 255, 0.5);
    margin: -10px 0 20px 0;
  }
  .create-button {
    width: 251px;
    height: 56px;
    border-radius: 40px;
    opacity: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    background: linear-gradient(
        289deg,
        rgba(255, 255, 255, 0) 22%,
        rgba(255, 255, 255, 0.2) 49%,
        rgba(255, 255, 255, 0) 75%
      ),
      linear-gradient(103deg, #4fdeff 0%, #e675ff 99%);
    .icon-music {
      width: 24px;
      height: 24px;
    }
    .create-text {
      font-size: 18px;
      font-weight: bold;
      line-height: 24px;
      color: #fff;
    }
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
